var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.js
var src_exports = {};
__export(src_exports, {
  BrowserSecurity: () => BrowserSecurity
});
module.exports = __toCommonJS(src_exports);

// ../../core/packages/core-react/src/utils/browser/BrowserHeadersBuilder.ts
var CSRF_TOKEN_NAME = "X-CSRF-Token";
var BrowserHeadersBuilder = class {
  headers = {
    "content-type": "application/json"
  };
  addCsrfFromCookie(cookie) {
    if (cookie?.get(CSRF_TOKEN_NAME)) {
      this.headers[CSRF_TOKEN_NAME] = cookie.get(CSRF_TOKEN_NAME);
    }
  }
  addAuthorization(accessToken) {
    if (accessToken) {
      this.headers.authorization = `Bearer ${accessToken}`;
    }
  }
  addTestId(testId) {
    if (testId) {
      this.headers["x-test-id"] = testId;
    }
  }
  build() {
    return this.headers;
  }
};

// ../../core/packages/core-react/src/utils/browser/BrowserFetcher.ts
var BrowserFetcher = class {
  fetchApi = globalThis.fetch ? globalThis.fetch.bind(globalThis) : globalThis.fetch;
  cookie;
  constructor(fetchApi, options = {}) {
    this.fetchApi = fetchApi || this.fetchApi;
    this.cookie = options.cookie;
  }
  call(options) {
    const headersBuilder = new BrowserHeadersBuilder();
    headersBuilder.addCsrfFromCookie(this.cookie);
    headersBuilder.addAuthorization(options.accessToken);
    headersBuilder.addTestId(options.testId);
    const fetchOptions = {
      method: options.method,
      headers: headersBuilder.build(),
      signal: options.abortSignal,
      credentials: "include",
      body: options.payload
    };
    return this.fetchApi(options.url, fetchOptions).then((r) => {
      if (r.status >= 400) {
        throw new Error(r.statusText || "Server error");
      }
      return r.json();
    });
  }
  get(options) {
    const { payload, ...remainingOptions } = options;
    const params = new URLSearchParams(options.payload).toString();
    const pathWithParams = options.url + (options.payload ? `?${params}` : "");
    return this.call({ ...remainingOptions, method: "GET", url: pathWithParams });
  }
  post(options) {
    const payload = JSON.stringify(options.payload);
    return this.call({ ...options, method: "POST", payload });
  }
};

// ../../core/packages/core-react/src/providers/Security/BrowserSecurity.ts
var guestUser = {
  id: "guestuser",
  firstName: "Guest",
  lastName: "User",
  campus: {
    name: "Risk & Safety",
    code: "YOLO",
    uri: "https://auth.riskandsafety.com/rss/yolo"
  },
  email: "guest.user@riskandsafety.com",
  rss: false
};
var getSpoofedUser = (cookie = document.cookie, storage = localStorage) => {
  const cookies = decodeURIComponent(cookie).split(";").map((c) => c.trim());
  const [spoofCookie] = cookies.filter((c) => c.match(/^RSS:SPOOF:USER/));
  if (!spoofCookie) {
    return { isSpoofed: false, spoofedUser: null };
  }
  const [, spoofId] = spoofCookie.split("=").map((value) => value.trim());
  const spoofHistory = storage.getItem("rss:spoof:history");
  if (spoofHistory) {
    try {
      const [spoofedUser] = JSON.parse(spoofHistory);
      return { isSpoofed: true, spoofedUser };
    } catch (e) {
      console.log(e);
    }
  }
  return {
    isSpoofed: true,
    spoofedUser: {
      firstName: "Spoofed",
      lastName: "User",
      email: "",
      id: spoofId || "",
      campus: { name: "", code: "", uri: "" },
      rss: true
    }
  };
};
var BrowserSecurity = class {
  constructor(locationUtils, baseAuthPath) {
    this.locationUtils = locationUtils;
    this.baseAuthPath = baseAuthPath;
  }
  get user() {
    const storedUser = window.localStorage.getItem("RSS:USER");
    if (!storedUser) {
      return guestUser;
    }
    const user = JSON.parse(storedUser);
    const { isSpoofed, spoofedUser } = getSpoofedUser();
    return user.rss && isSpoofed ? spoofedUser : user;
  }
  get isAuthenticated() {
    const storedUser = window.localStorage.getItem("RSS:USER");
    return !!storedUser;
  }
  get isSpoofedUser() {
    const { isSpoofed } = getSpoofedUser();
    return isSpoofed;
  }
  login() {
    this.redirect("/login", { originalUri: this.locationUtils.href });
  }
  // Needed for Platform campus to medcenter switcher
  // Existing functionality expects to be able to refresh the token from the client side in order to get an updated user claim
  async refresh(refreshUrl) {
    const fetchClient = new BrowserFetcher();
    await fetchClient.post({ url: refreshUrl, payload: {} }).catch(() => {
    });
  }
  logout(returnPath) {
    const returnUrl = this.buildUrl(returnPath);
    window.localStorage.setItem("RSS:REDIRECT_URI", this.locationUtils.href);
    this.redirect("/api/pre-logout", { logoutUri: returnUrl });
  }
  redirect(path, params) {
    this.locationUtils.assign(this.buildUrl(this.baseAuthPath + path, params));
  }
  buildUrl(path, params) {
    const url = new URL(path, this.locationUtils.href);
    if (params) {
      Object.entries(params).forEach(([name, value]) => url.searchParams.append(name, value));
    }
    return url.toString();
  }
  getStorageItem(name) {
    return window.localStorage.getItem(name);
  }
  getQueryStringItem(name) {
    return new URL(this.locationUtils.href).searchParams.get(name);
  }
  getCookie(name) {
    const cookies = document.cookie.split(";").map((s) => s.trim()).filter(Boolean).map((x) => x.split("=")).reduce((prev, [k, v]) => k && v ? { ...prev, [k]: decodeURIComponent(v) } : prev, {});
    return cookies[name];
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BrowserSecurity
});
